export * from "./types";
import slice from "./slice";
export const { resetCreatePharmacyInfoAction, resetPostPharmacyInfoAction, resetPutPharmacyInfoAction } = slice.actions;
